module.exports = __webpack_public_path__ + "img/twitter-icon.6fc59959.svg";